import { jsx as _jsx } from "react/jsx-runtime";
import { FieldWrapper } from '../FieldWrapper';
import { TrimmedInput } from '../TrimmedInput';
export const MirCardPaymentField = ({ value, required, onValueChange, validationInfo, }) => {
    return (_jsx(FieldWrapper, { label: "\u041A\u0430\u0440\u0442\u0430 \u041C\u0418\u0420", children: _jsx(TrimmedInput, { value: value, removeAllSpace: true, required: required, mask: "9999999999999999999", onValueChange: onValueChange, validationInfo: validationInfo }) }));
};
